import useSWR from "swr";
import { usePlace } from "../providers/PlaceProvider";
import { SAASClient } from "../HTTPClient";

/**
 * The place's SMS campaigns, fetched once per load.
 *
 * Three callers want this list: ToDoProvider (has the merchant sent any?),
 * useDashboardData (the SMS charts) and the SMS ListView (the list itself).
 * ToDoProvider sits outside the route Suspense boundary and the other two
 * inside it, so the requests only overlap when the lazy chunk happens to land
 * in time — measured as 1 on /, 2 on /google-performance and 2 on
 * /sms-campaigns. One SWR key makes the mount order irrelevant.
 */
export function useSmsCampaigns() {
  const { selectedPlace } = usePlace();

  const { data, isLoading, mutate } = useSWR(
    selectedPlace?.id ? ["sms-campaigns", selectedPlace.id] : null,
    () =>
      SAASClient.get("/sms/campaigns?placeId=" + selectedPlace!.id)
        // A 200 that isn't an array (the dev server's SPA fallback when
        // VITE_SAAS_API_URL is unset) never rejects, so .catch alone is not
        // enough — and every consumer below would inherit the HTML.
        .then(({ data: list }) => (Array.isArray(list) ? list : []))
        .catch(() => [] as any[]),
    { revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false }
  );

  return {
    campaigns: (data ?? []) as any[],
    loaded: !!selectedPlace?.id && !isLoading,
    refresh: mutate,
  };
}
